var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.control.additionalLabelClass,attrs:{"id":_vm.control.uniqueId,"for":_vm.control.forAttribute},domProps:{"innerHTML":_vm._s(_vm.control.label)}})
}
var staticRenderFns = []

export { render, staticRenderFns }